import { useEffect, useMemo, useState } from 'react'
import { useChangeCandidateStageMutation } from '../../slice/candiddateApiSlice';
import { permissionsActions } from '../../../../shared/utils/interfaces/AuthInterface';
import { useDispatch, useSelector } from 'react-redux';
import { selectAiFilters, selectAiFiltersArray, selectCandidateProfile, selectCandidates, selectCandidatesFilters, selectCurrentHiringStages, setAiSearchFilter, setCandidateProfile, setCandidatesFilter, setCurrentHiringStages, setStageChange, removeCandidateById, setIsChangingCandidateStage, selectIsChangingCandidateStage } from '../../slice/candidateSlice';
import { GlobalStageTypesId, IAIFilter, ICandidatesFilter, IHiringStage, IHiringStageModi, candidatesSorting } from '../../../../shared/utils/interfaces/candidatesListFace';
import { Button, Dropdown, MenuProps, Tag, message } from 'antd';
import { candidatesPerPage, errorMessage, roleError } from '../../../../shared/utils/constantData';
import { convertToSent } from '../../../../shared/utils/functions/convertToSentWord';
import { analytics } from '../../../../shared/utils/analytics';
import { logEvent } from 'firebase/analytics';
import { WithTooltip } from '../../../../shared/components/tooltip.tsx/withTootip';
import { getImageUrl } from '../../../../shared/utils/functions/images';
import { tabs } from '../../../../shared/utils/interfaces/createJobTabs';
import { usePermissions } from '../../../../shared/utils/customHooks/usePermissions';
import { selectRolePerJob } from '../../../authentication/slice/authSlice';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useCandidateNavigation } from '../../../../shared/utils/customHooks/useCandidateNavigation';
import { relocateNotification } from '../../../../shared/utils/functions/relocateNotification';
import { removeCandidateFromIds } from '../../../../shared/utils/functions/removeCandidateFromIds';
import { setMobileTabsMenuExpanded } from '../../../../shared/components/Menu/slice/tabsMenuSlice';

function ChangeStageActions({ candidateId, hiringStageId, isProfilePage = false }: { candidateId: number, hiringStageId: number, isProfilePage?: boolean }) {
    const dispatch = useDispatch()
    const location = useLocation()
    const navigate = useNavigate()
    const { jobId } = useParams()
    const { updateJobHiringStage } = permissionsActions
    const { hasJobPermission } = usePermissions()
    const rolePerJob = useSelector(selectRolePerJob)
    const [changeCandidateStage, { isLoading, isSuccess, isError, data }] = useChangeCandidateStageMutation();
    const [isChangingStage, setIsChangingStage] = useState(false);
    const [selectedStage, setSelectedStage] = useState<number | false>()
    const [nextStage, setNextStage] = useState<string | false>('');
    const [nextStageId, setNextStageId] = useState<number | false>(0);
    const [isLastStage, setIsLastStage] = useState(false)
    const [lastCandidateStageLabel, setLastCandidateStageLabel] = useState<string | false>('');
    const [selectedStageKey, setSelectedStageKey] = useState<any>(0);
    const [isRelocated, setIsRelocated] = useState<boolean>(false);
    const currentStages: IHiringStage[] = useSelector(selectCurrentHiringStages);
    const aiFiltersArray: { id: number, question: string }[] = useSelector(selectAiFiltersArray);
    const candidatesFilter: ICandidatesFilter = useSelector(selectCandidatesFilters);
    const candidatesAiFilter: IAIFilter = useSelector(selectAiFilters);
    const candidate = useSelector(selectCandidateProfile)
    const candidates = useSelector(selectCandidates)
    const isGlobalChangingStage = useSelector(selectIsChangingCandidateStage)
    const { handleCandidateNavigate } = useCandidateNavigation()

    const currentStagesModi: IHiringStageModi[] | undefined = useMemo(() => {
        const currentStageId = isChangingStage ? selectedStageKey : hiringStageId;
        return currentStages?.length !== 0 &&
            Array.isArray(currentStages) ? [...currentStages.map((item: IHiringStage) => ({
                label: `Send to ${item?.name.charAt(0).toUpperCase() + item.name.slice(1)}`,
                key: item?.id,
                disabled: item?.id === currentStageId,
                danger: item?.name === tabs.rejected
            }))] : undefined;
    }, [hiringStageId, currentStages, isChangingStage, selectedStageKey]);

    const relocateCandidate = () => {
        dispatch(setCandidatesFilter({ ...candidatesFilter, hiringStageId: selectedStage, sortBy: candidatesSorting[0].value }));
        if (isProfilePage) navigate(`/jobs/${candidate?.jobId}/candidates?hiringStageId=${selectedStage}`);
        else {
            dispatch(setMobileTabsMenuExpanded(null));
            navigate(`/jobs/${jobId}/candidates?hiringStageId=${selectedStage}`);
        }
    }

    useEffect(() => {
        const lastIndex = Array.isArray(currentStagesModi) && currentStagesModi.length - 1;
        const currentStageId = isChangingStage ? selectedStageKey : hiringStageId;
        let indexOfCurrentStage: number | false = Array.isArray(currentStagesModi) && currentStagesModi.findIndex(stage => stage.key === currentStageId);
        if (!currentStageId) {
            setNextStage(Array.isArray(currentStagesModi) && currentStagesModi[currentStageId]?.label)
            setNextStageId(Array.isArray(currentStagesModi) && currentStagesModi[currentStageId]?.key)

        } else if (indexOfCurrentStage !== false && lastIndex === indexOfCurrentStage) {
            setIsLastStage(true);
            setLastCandidateStageLabel(convertToSent(Array.isArray(currentStagesModi) && currentStagesModi[indexOfCurrentStage]?.label)
            )
        } else if (indexOfCurrentStage !== false) {
            setIsLastStage(false);
            setNextStage(Array.isArray(currentStagesModi) && currentStagesModi[indexOfCurrentStage + 1]?.label);
            setNextStageId(Array.isArray(currentStagesModi) && currentStagesModi[indexOfCurrentStage + 1]?.key)
        }
    }, [isChangingStage, hiringStageId, currentStagesModi, selectedStageKey])

    useEffect(() => {
        dispatch(setIsChangingCandidateStage(isLoading));
    }, [isLoading, dispatch]);

    useEffect(() => {
        if (isSuccess) {
            if (isProfilePage) {
                dispatch(setCandidateProfile({ ...candidate, ...data?.data }))
                const selectedStageGlobalTypeId = currentStages?.find(({ id }) => id === selectedStage)?.globalstagetypeid;
                dispatch(setStageChange(selectedStageGlobalTypeId))
                if (selectedStageGlobalTypeId === GlobalStageTypesId.rejected && !location?.state?.fromSearch && !location?.state?.fromSimilarity && isProfilePage) {
                    localStorage.removeItem("currentTab");
                    handleCandidateNavigate();
                }
            } else {
                dispatch(removeCandidateById(candidateId))
                dispatch(setCurrentHiringStages(data?.data?.pipelineStages))
                removeCandidateFromIds(candidateId)
            }
            logEvent(analytics, 'Change candidate stage from candidate profile')
            setSelectedStageKey(selectedStage)
            setIsChangingStage(true)

            if (!aiFiltersArray.length) dispatch(setCandidatesFilter({
                ...candidatesFilter, page: 1, perPage: candidatesPerPage,
                hiringStageId: isRelocated ? selectedStage : candidatesFilter?.hiringStageId,
            }))
            else dispatch(setAiSearchFilter({ ...candidatesAiFilter, page: 1 }))
            const destinationStage = currentStages?.find(stage => stage?.id === selectedStage)?.name;
            const selectedCandidate = isProfilePage ? candidate : candidates?.find(item => item?.id === candidateId)
            relocateNotification({
                candidate: selectedCandidate, destination: destinationStage, isStage: true, onClick: () => {
                    setIsRelocated(true);
                    relocateCandidate();
                }
            });
        } else if (isError) {
            message.error(`${errorMessage}, the hiring stage is not updated`)
        }
        // eslint-disable-next-line
    }, [isError, isSuccess, dispatch, aiFiltersArray.length, selectedStage, data, isRelocated]);

    const handleCheckedHiringStage = async () => {
        if (isGlobalChangingStage) return;
        const candidateData = {
            applicationId: Number(candidateId),
            pipelineHiringStageId: nextStageId,
        }
        setSelectedStage(candidateData.pipelineHiringStageId);
        await changeCandidateStage(candidateData);
    };

    const handleChangeHiringStage: MenuProps['onClick'] = async (e) => {
        if (isGlobalChangingStage) return;
        const candidateData = {
            applicationId: Number(candidateId),
            pipelineHiringStageId: Number(e?.key)
        }
        setSelectedStage(candidateData.pipelineHiringStageId);
        await changeCandidateStage(candidateData);
    };

    return (
        <>
            {currentStagesModi && (
                <WithTooltip
                    visible={!hasJobPermission(rolePerJob, updateJobHiringStage)}
                    placement='bottom'
                    title={roleError}
                >
                    <div className="flex items-center w-auto my-auto ml-auto flex-nowrap group min-w-max h-fit">
                        <>
                            {isLastStage ? <Tag className='ant-tag-info-ghost tag-lg me-0 min-w-max'>{lastCandidateStageLabel && lastCandidateStageLabel}<img src={getImageUrl('blueCheck')} className='inline ml-2 btn-icon' alt='arrow' /></Tag> :
                                <Button
                                    loading={isLoading}
                                    disabled={!hasJobPermission(rolePerJob, updateJobHiringStage)}
                                    className='btn-primary-light !rounded-l-md !rounded-br-none !rounded-tr-none disabled:bg-transparent' onClick={handleCheckedHiringStage}>
                                    {isLastStage ? lastCandidateStageLabel : nextStage}
                                </Button>}
                            <Dropdown
                                className={`mr-0 cursor-pointer rounded-r-md p-2 ${!hasJobPermission(rolePerJob, updateJobHiringStage) ? '!bg-transparent border-r border-y !border-y-indigo-200 !border-r-indigo-200 !cursor-not-allowed' : ''} btn-primary-light border-l !border-l-indigo-200 shadow-sm`}
                                trigger={['click']}
                                disabled={!hasJobPermission(rolePerJob, updateJobHiringStage)}
                                dropdownRender={menu => (
                                    <div className={`overflow-y-auto bg-white border border-gray-300 rounded-md shadow-md ${isProfilePage ? 'max-h-[26.25rem]' : 'max-h-52'}`}>
                                        {menu}
                                    </div>
                                )}
                                menu={{
                                    items: currentStagesModi,
                                    onClick: handleChangeHiringStage,
                                }} >
                                <img src={!hasJobPermission(rolePerJob, updateJobHiringStage) ? getImageUrl('grayArrowDown') : getImageUrl('ChevronDown')} alt='arrow' onClick={(e) => e.stopPropagation()} />
                            </Dropdown>
                        </>
                    </div>
                </WithTooltip>
            )}
        </>
    )
}

export default ChangeStageActions